import React from 'react'
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import badgesAward from "../../../../../styles/img/badgesAward.png"
import {UiButtonPrimary} from "../../../../_uiMocks/components/form/UiButton"

export default function GetBadges(props) {


    return (
        <>
        <div className='sb-get-badges ps-3 pt-2'>
            <UiSingleRow>
                <UiCol lg="8" >
                    <h3>Get Badges</h3>
                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                    <UiButtonPrimary btnName="Browse All Programmes"/>
                </UiCol>
                <UiCol lg="4" className="text-center">
                    <img src={badgesAward}/>
                </UiCol>
            </UiSingleRow>
         </div>
        </>
    )
}
